document.addEventListener("DOMContentLoaded", function () {
  'use strict'

  // Class constructor for Komodo Accordion component.
  // Implements Komodo component design pattern
  //
  // @constructor
  // @param {HTMLElement} The element that will be upgraded to be Komodo Accordion.
  var KomodoAccordion = function KomodoAccordion(element) {
    this.element_ = element;
    this.accordions = this.element_.getElementsByClassName(this.cssClasses_.ACCORDION);
    if (this.element_.getAttribute("data-open-one")) {
      this.openAccordion = null;
    }
    // Open Accordions
    for (var i = 0; i < this.accordions.length; i++) {
      var accordion = this.accordions[i];
      accordion.querySelector("." + this.cssClasses_.HEADER).addEventListener('click', this.toggle.bind(this));
      // add keyboard event listener to the header of the accordion
      accordion.querySelector("." + this.cssClasses_.HEADER).addEventListener('keydown', function (event) {
        if (event.keyCode === this.keyCodes.ENTER || event.keyCode === this.keyCodes.SPACE) {
          event.preventDefault();
          this.toggle(event);
        }
      }.bind(this));
    }
  };
  window['KomodoAccordion'] = KomodoAccordion;

  // Store strings for class names defined by this component that are used in
  // Javascript. This allows us to simply change it in one place should we decide
  // to modify at a later date.
  //
  // @enum {string}
  // @private
  KomodoAccordion.prototype.cssClasses_ = {
    OPEN: 'open',
    ACCORDION: 'accordion',
    HEADER: 'accordion-header',
    BODY: 'accordion-body',
  };

  // Store strings for keycodes defined for this component that are used in
  // Javascript. This allows us to enable keyboard navigation for the component.
  //
  // @enum {string}
  // @private
  KomodoAccordion.prototype.keyCodes = {
    ENTER: 13,
    SPACE: 32,
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
  };

  // Toggle the accordion.
  //
  // @public
  KomodoAccordion.prototype.toggle = function (event) {
    if (event.target.parentElement.classList.contains(this.cssClasses_.OPEN)) {
      this.close(event.target.parentElement);
    } else {
      this.open(event.target.parentElement);
    }
  };
  KomodoAccordion.prototype['toggle'] = KomodoAccordion.prototype.toggle;

  // Open the accordion.
  //
  // @public
  KomodoAccordion.prototype.open = function (element) {
    if (this.element_.getAttribute("data-open-one")) {
      if (this.openAccordion) {
        this.close(this.openAccordion);
      }
      this.openAccordion = element;
      this.element_.querySelector('.' + this.cssClasses_.BODY).focus();
    }

    element.dispatchEvent(createEvent('opening.komodo.accordion', false, true));
    element.classList.add(this.cssClasses_.OPEN);
    if(element.querySelector('.accordion-header')) {
      element.querySelector('.accordion-header').ariaExpanded = "true";
    }
    element.dispatchEvent(createEvent('opened.komodo.accordion', false, true));
  };
  KomodoAccordion.prototype['open'] = KomodoAccordion.prototype.open;

  // Close the accordion.
  //
  // @public
  KomodoAccordion.prototype.close = function (element) {
    element.dispatchEvent(createEvent('closing.komodo.accordion', false, true));
    element.classList.remove(this.cssClasses_.OPEN);
    if(element.querySelector('.accordion-header')) {
      element.querySelector('.accordion-header').ariaExpanded = "false";
    }
    element.dispatchEvent(createEvent('closed.komodo.accordion', false, true));
  };
  KomodoAccordion.prototype['close'] = KomodoAccordion.prototype.close;

  // Bind the keyboard events with the accordion.
  //
  // @public
  KomodoAccordion.prototype.onKeyDown = function (event, index) {

  };

  // Helper function to create a custom event in IE11
  function createEvent(eventType, bubbles, cancelable) {
    var event = document.createEvent("Event");
    event.initEvent(eventType, bubbles, cancelable);
    return event;
  }

  // The component registers itself. It can assume componentHandler is available
  // in the global scope.
  componentHandler.register({
    constructor: KomodoAccordion,
    classAsString: 'KomodoAccordion',
    cssClass: 'accordions',
    widget: true
  });
});